export const BlockedContactIcon = () => {
  return (
    <svg
      data-name="Grupo 7103"
      height="30.769"
      id="Grupo_7103"
      viewBox="0 0 38.239 35.769"
      width="32.239"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="9.648"
        cy="9.648"
        data-name="Elipse 1840"
        fill="#ff715b"
        id="Elipse_1840"
        rx="9.648"
        ry="9.648"
        transform="translate(5.644 0)"
      />
      <path
        d="M1381.317,717.1h0a7.617,7.617,0,1,0,7.617,7.617A7.681,7.681,0,0,0,1381.317,717.1Zm-.032,3.047a4.064,4.064,0,0,1,1.523.286l-5.681,5.681a4.806,4.806,0,0,1-.286-1.523A4.416,4.416,0,0,1,1381.285,720.147Zm.032,8.919h-.063a4.221,4.221,0,0,1-1.428-.254l5.65-5.649a4.224,4.224,0,0,1,.254,1.428A4.4,4.4,0,0,1,1381.317,729.065Z"
        data-name="Trazado 4389"
        fill="#ff715b"
        id="Trazado_4389"
        transform="translate(-1350.695 -696.978)"
      />
      <g data-name="Grupo 7095" id="Grupo_7095" transform="translate(0 19.293)">
        <path
          d="M1321.017,722.934a10.726,10.726,0,0,1,3.777-8.188l-.032-.032a1.3,1.3,0,0,0-1.428,0,11.833,11.833,0,0,1-13.616,0,1.24,1.24,0,0,0-1.428,0c-5.4,3.586-6.919,10.537-6.919,10.537s-1.4,5.713,4.253,5.713h19.011A10.727,10.727,0,0,1,1321.017,722.934Z"
          data-name="Trazado 4390"
          fill="#ff715b"
          id="Trazado_4390"
          transform="translate(-1301.218 -714.487)"
        />
      </g>
    </svg>
  );
};
